import { checkUrl } from './check-urls';
export function getValueByUrlKey(possibleKeys, object) {
    const key = possibleKeys.find((pk) => checkUrl(pk));
    return key ? object[key] : undefined;
}
